import { z } from 'zod';

export const ProductDetailSlotsDTOTypes = {
    deliveryAndReturnsInfosContent: z.literal('deliveryandreturnsinfoscontent'),
    paymentReinsurance: z.literal('payment_reinsurance'),
};
